import { render, staticRenderFns } from "./inputArea.vue?vue&type=template&id=16d9d275&scoped=true&"
import script from "./inputArea.vue?vue&type=script&lang=js&"
export * from "./inputArea.vue?vue&type=script&lang=js&"
import style0 from "./inputArea.vue?vue&type=style&index=0&id=16d9d275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d9d275",
  null
  
)

export default component.exports